<script>
    import { buttonStates } from '@repo/config/Global';

    /**
     * @typedef {Object} Props
     * @property {boolean} [disabled]
     * @property {any} [state]
     * @property {any} title
     * @property {any} [icon]
     * @property {string} [align]
     * @property {number} [tabindex]
     * @property {any} [instruction]
     * @property {any} [css]
     * @property {any} [id]
     * @property {any} [onclick]
     */
    let {
        disabled = false,
        state = buttonStates.NEUTRAL,
        title,
        icon = null,
        align = 'right',
        instruction = null,
        css = null,
        id = null,
        onclick = () => {},
        type = 'submit',
    } = $props();

    let tabindex = $derived.by(() => {
        return disabled ? null : 0;
    });
</script>

<button
    onclick={onclick || undefined}
    {id}
    type={type}
    {tabindex}
    class={`button submit interactive ${state} ${align} ${
        disabled ? 'disabled' : ''
    } ${css}`}
    {disabled}
    {title}
    aria-label={title}
>
    {#if align === 'left' && icon}
        <i class="material-icons" aria-hidden="true">{icon}</i>
    {/if}
    <span>{title}</span>
    {#if align === 'right' && icon}
        <i class="material-icons" aria-hidden="true">{icon}</i>
    {/if}
</button>
{#if instruction}
    <small class="instruction">{instruction}</small>
{/if}

<style>
    .button {
        display: flex;
        align-items: center;
        padding: 0.75rem 1rem;
        border-radius: 0.5rem;
        align-self: center;
    }

    .button.align-left {
        align-self: flex-start;
    }

    .button span {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 0.8rem;
        line-height: 1.5rem;
    }

    .button i {
        font-size: 1.5rem;
    }

    .right i {
        margin-left: 0.75rem;
    }

    .left i {
        margin-right: 0.75rem;
    }

    .button + .button {
        margin-left: 0.75rem;
    }

    .button:hover {
        opacity: 0.8;
        box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.25);
    }

    .button_state_error {
        background-color: crimson;
        color: white;
    }

    .button_state_warn {
        background-color: rgb(255, 192, 74);
        color: #333;
    }

    .button_state_waiting {
        background-color: rgb(74, 198, 255);
        color: #333;
    }

    .button_state_neutral {
        background-color: rgb(199, 199, 199);
        color: #333;
    }

    .button_state_success {
        background-color: rgb(74, 255, 83);
        color: #333;
    }

    .disabled {
        pointer-events: none;
        opacity: 0.25;
    }

    .instruction {
        font-size: 0.75rem;
        font-weight: 400;
        text-transform: none;
        margin: 0.5rem 0 0 0.25rem;
        opacity: 0.8;
        align-self: center;
    }
</style>
